<button type="button" class="btn btn-default" *ngIf="showButton" (click)="buttonClicked()">{{buttonLabel}}</button>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-action-toolbar/request-action-toolbar-button/request-action-toolbar-button.component.html